import React from 'react'
import { RouteProps } from 'react-router-dom'

import ConfirmationTemplate from '../../../templates/Confirmation'

import { useAuthenticationProps } from './useProps'

const AuthenticationPage: React.FC<RouteProps> = () => {
  const templateProps = useAuthenticationProps()

  return <ConfirmationTemplate {...templateProps} />
}

export default AuthenticationPage
